import React from 'react';

const AboutMe = () => {

  return (
    <section id="about">
      <div className="container hidden">
        <div className="about-me">
          <h2 className="title">About Me</h2>
          <div className='about-me-content'>
            <div className="text-section">

              <p className="introduction">
              Hello, I'm Chris Cheung, a First Class Honours graduate in Computer Science from The Chinese University of Hong Kong, currently pursuing my MSc in the same field. I'm passionate about crafting immersive digital experiences through web development, game design, and educational technology.
              </p>

              <p className="introduction">
              I specialize in developing software applications, interactive websites, and engaging games. My technical toolkit includes C#, JavaScript, Python, and Java, along with frameworks like React and Node.js. I'm also experienced with databases such as MongoDB, Firebase, and PostgreSQL.
              </p>

              <p className="introduction">
              My professional journey includes leading the development of WordyPals, an AI-powered English learning app adopted by over 12 schools in Hong Kong, and Mind Voyage, a multi-role educational platform for EdUHK. I’ve built real-time multiplayer games in Unity, designed AR/VR applications for inclusive education, and conducted training workshops in secondary schools.
              </p>

              <p className="introduction">
              In my free time, I enjoy creating video games, playing boardgames, petting cats, and exploring pixel art and film. I'm always eager to learn, grow, and collaborate on innovative projects that make a meaningful impact.
              </p>

              <p className="introduction">
              I'm currently seeking challenging roles in software development, web development, and game development, where I can contribute my skills and creativity to exciting new ventures.
              </p>
              
            </div>
            <div className="image-section">
              <img src="images/Cat.jpg" alt="Chris Cheung" className="profile-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;